export default "__VITE_ASSET__A43$AVqq__"